import { z } from "zod";

export const equipmentTypeCategories = [
  "vehicle",
  "tool",
  "heavy_equipment",
  "attachment",
] as const;

export const EquipmentTypeSchema = z.object({
  id: z.string().uuid().describe("ID"),
  slug: z.string().describe("Slug"),
  label: z.string().describe("Label"),
  category: z.enum(equipmentTypeCategories).describe("Category"),
  source_pack_id: z.string().uuid().nullable().describe("Source Pack"),
  description: z.string().nullable().describe("Description"),
  is_active: z.boolean().describe("Active"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
});
export type EquipmentType = z.infer<typeof EquipmentTypeSchema>;

export const EquipmentTypeQuerySchema = z.object({
  // schema-check-ignore: query-filter — null/"" semantically distinct from "no filter applied"
  category: z.enum(equipmentTypeCategories).optional(),
  // schema-check-ignore: query-filter — null/"" semantically distinct from "no filter applied"
  source_pack_id: z.string().uuid().optional(),
  is_active: z
    .string()
    .transform((v) => v === "true")
    .optional(),
  search: z.string().optional(),
});
